const GeneralType = {
    key: '',
    value: ''
}

export const initialSettings = {
    facebook: GeneralType,
    twitter: GeneralType,
    linkedin: GeneralType,
    instagram: GeneralType,
    headerPhone: GeneralType,
    headerAddress: GeneralType,
    footerPhone: GeneralType,
    footerAddress: GeneralType,
    footerEmail: GeneralType,
    location: GeneralType
}
